<template>
    <div class="c-date-goto-month">
        <div class="c-date-goto-month__title">Jump to month</div>
        <v-select :options="options" :searchable="false" v-model="selected" :value="selected" @input="chosenMonth"></v-select>
    </div>
</template>

<script>
    import axios from 'axios'
    import moment from 'moment'
    import vSelect from 'vue-select'
    import {EventBus} from "../event-bus"

    export default {
        name: "GotoMonth",
        components: {
            'v-select': vSelect
        },
        props: ['selectedMonth'],
        data() {
            return {
                selected: null,
                options: [],
            }
        },
        mounted() {
            this.fetchMonths()
            this.selected = this.selectedMonth
            EventBus.$on('updateMonth', this.updateSelector)
        },
        methods: {
            chosenMonth(month) {
                EventBus.$emit('gotoMonth', month)
            },
            fetchMonths() {
                axios.get(window.ajax.url, {
                    params: {
                        action: 'basethemeCalendarMonthListRequest',
                    }
                }).then((response) => {
                    let months = response.data.months
                    this.options = months
                }).catch(function (error) {
                    console.log(error)
                })
            },
            updateSelector(viewTitle) {
                this.selected = moment(viewTitle, 'MMMM YYYY', true).format('MMMM YYYY')
            }
        }
    }
</script>

<style>
    @import '~vue-select/dist/vue-select.css'
</style>
